import { RecordTaskStatus, RecordTaskType } from "@modules/records/types/record";

export class TaskTemplate {
  key?: string;
  name?: string;
  type?: RecordTaskType;
  status?: RecordTaskStatus;
  needs?: string[];
  body?: any;

  static getGeneralTasks(): TaskTemplate[] {
    return [
      {
        "type": "irisUpload",
        "key": "vodIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "iris": {
            "type": "vod",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/vod/",
            "profile": ""
          }
        }
      },
      {
        "type": "linearMetadata",
        "key": "linearMetadata",
        "name": "Metadata",
        "needs": [
          "linearTrim"
        ],
        "body": {}
      },
      {
        "type": "linearTrim",
        "key": "linearTrim",
        "name": "Trim",
        "needs": [
          "recording",
          "maxTrim"
        ],
        "body": {}
      },
      {
        "type": "maxUpload",
        "key": "maxUpload",
        "name": "Upload",
        "needs": [
          "maxStartManualUpload",
          "maxValidateFiles"
        ],
        "body": {
          "awsSnsTopic": "arn:aws:sns:us-east-1:432857103480:Roadrunner-Prod"
        }
      },
      {
        "type": "startManualTask",
        "key": "linearStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "validateFiles",
        "key": "linearValidateFiles",
        "name": "Validate Files",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--linear"
        }
      },
      {
        "type": "validateFiles",
        "key": "vodValidateFiles",
        "name": "Validate Files",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--vod"
        }
      },
      {
        "type": "startManualTask",
        "key": "archiveStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "archiveUpload",
        "key": "archiveUpload",
        "name": "Upload",
        "needs": [
          "archiveStartManualUpload",
          "archiveValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "archiveOvertimeMetadata",
        "key": "archiveOvertimeMetadata",
        "name": "Archive Overtime Metadata",
        "needs": [
          "maxParityOvertimeMetadata",
          "archiveMetadata"
        ],
        "body": {
          "archiveOvertime": {
            "fileNamePattern": "Overtime"
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxParityIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "iris": {
            "type": "maxParity",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/maxParity/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "linearIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "iris": {
            "type": "linear",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/linear/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "iris": {
            "type": "max",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/max/",
            "profile": ""
          }
        }
      },
      {
        "type": "collectS3Links",
        "key": "collectS3Links",
        "name": "Collect S3 Links",
        "needs": [
          "backupUpload"
        ],
        "body": {}
      },
      {
        "type": "archiveOvertimeUpload",
        "key": "archiveOvertimeUpload",
        "name": "Overtime Upload",
        "needs": [
          "archiveOvertimeMetadata",
          "archiveValidateFiles",
          "archiveStartManualUpload"
        ],
        "body": {}
      },
      {
        "type": "maxParityTrim",
        "key": "maxParityTrim",
        "name": "Trim",
        "needs": [
          "maxTrim"
        ],
        "body": {
          "maxParity": {
            "fileNamePattern": "Bill_Maher_Interlace_Max_{date}"
          }
        }
      },
      {
        "type": "contentAcquisitionUpload",
        "key": "contentAcquisitionUpload",
        "name": "Upload",
        "needs": [
          "contentAcquisitionStartManualUpload",
          "contentAcquisitionValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "contentAcquisitionIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "iris": {
            "type": "contentAcquisition",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/contentAcquisition/",
            "profile": ""
          }
        }
      },
      {
        "type": "maxParityMetadata",
        "key": "maxParityMetadata",
        "name": "Metadata",
        "needs": [
          "maxParityTrim"
        ],
        "body": {}
      },
      {
        "type": "maxMetadata",
        "key": "maxMetadata",
        "name": "Metadata",
        "needs": [
          "maxTrim"
        ],
        "body": {
          "max": {
            "dolby": true,
            "dolbyFileNamePattern": "Bill_Maher_Progressive_Max_ADM_{date}"
          }
        }
      },
      {
        "type": "contentAcquisitionMetadata",
        "key": "contentAcquisitionMetadata",
        "name": "Metadata",
        "needs": [
          "contentAcquisitionTranscode",
          "recording",
          "maxMetadata"
        ],
        "body": {
          "contentAcquisition": {
            "cc": [
              "en"
            ]
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "contentAcquisitionStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "archiveIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "archiveMetadata",
          "archiveOvertimeMetadata"
        ],
        "body": {
          "iris": {
            "type": "archive",
            "bucket": "s3://iris-anywhere/output/Bill_Maher/{date}/archive/",
            "profile": ""
          }
        }
      },
      {
        "type": "validateFiles",
        "key": "archiveValidateFiles",
        "name": "Validate Files",
        "needs": [
          "archiveMetadata",
          "archiveOvertimeMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--archive"
        }
      },
      {
        "type": "maxParityUpload",
        "key": "maxParityUpload",
        "name": "Upload",
        "needs": [
          "maxParityStartManualUpload",
          "maxParityValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "archiveMetadata",
        "key": "archiveMetadata",
        "name": "Archive Metadata",
        "needs": [
          "maxParityUpload",
          "maxUpload"
        ],
        "body": {
          "archive": {
            "fileNamePattern": "RealTimeWithBillMaher"
          }
        }
      },
      {
        "type": "maxParityOvertimeTrim",
        "key": "maxParityOvertimeTrim",
        "name": "Overtime Trim",
        "needs": [],
        "body": {
          "maxParityOvertime": {
            "fileNamePattern": "Bill_Maher_Interlace_Max_{date}_ot"
          }
        }
      },
      {
        "type": "maxParityOvertimeMetadata",
        "key": "maxParityOvertimeMetadata",
        "name": "Overtime Metadata",
        "needs": [
          "maxParityOvertimeTrim"
        ],
        "body": {}
      },
      {
        "type": "contentAcquisitionTranscode",
        "key": "contentAcquisitionTranscode",
        "name": "Transcode",
        "needs": [
          "linearTrim",
          "maxParityTrim"
        ],
        "body": {
          "contentAcquisition": {
            "fileNamePattern": "RBM_2403_718_Original_16351_OV-2997DFTextedHDSDR_en-US_Rev000"
          }
        }
      },
      {
        "type": "backupUpload",
        "key": "backupUpload",
        "name": "Backup Upload",
        "needs": [
          "recording",
          "vodUpload",
          "maxParityUpload",
          "maxUpload",
          "archiveUpload",
          "archiveOvertimeUpload"
        ],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {}
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "vodStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxParityStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "validateFiles",
        "key": "maxParityValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--maxp"
        }
      },
      {
        "type": "validateFiles",
        "key": "contentAcquisitionValidateFiles",
        "name": "Validate Files",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--ca"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--max"
        }
      },
      {
        "type": "vodTrim",
        "key": "vodTrim",
        "name": "Trim",
        "needs": [
          "maxParityTrim"
        ],
        "body": {}
      },
      {
        "type": "vodMetadata",
        "key": "vodMetadata",
        "name": "Metadata",
        "needs": [
          "vodTrim"
        ],
        "body": {}
      },
      {
        "type": "vodUpload",
        "key": "vodUpload",
        "name": "Upload",
        "needs": [
          "vodStartManualUpload",
          "vodMetadata"
        ],
        "body": {}
      },
      {
        "type": "linearUpload",
        "key": "linearUpload",
        "name": "Upload",
        "needs": [
          "linearStartManualUpload",
          "linearValidateFiles"
        ],
        "body": {
          "linear": {
            "yakkoApiUrl": "https://yakko.msad.discovery.com/api/material/fulfillment"
          }
        }
      },
      {
        "type": "maxTrim",
        "key": "maxTrim",
        "name": "Trim",
        "needs": [],
        "body": {
          "max": {
            "fileNamePattern": "Bill_Maher_Progressive_Max_{date}"
          }
        }
      }
    ];
  }

  static getBillMaherAwsTasks(): TaskTemplate[] {
    return [
      {
        "type": "validateFiles",
        "key": "archiveValidateFiles",
        "name": "Archive Validate Files",
        "needs": [
          "archiveMetadata",
          "archiveOvertimeMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--archive"
        }
      },
      {
        "type": "contentAcquisitionTranscode",
        "key": "contentAcquisitionTranscode",
        "name": "Transcode",
        "needs": [
          "linearTrim",
          "maxParityTrim"
        ],
        "body": {
          "contentAcquisition": {
            "fileNamePattern": "Bill_Maher_Content_Acquisition_{date}"
          }
        }
      },
      {
        "type": "maxParityUpload",
        "key": "maxParityUpload",
        "name": "Upload",
        "needs": [
          "maxParityStartManualUpload",
          "maxParityMetadata"
        ],
        "body": {}
      },
      {
        "type": "maxParityOvertimeTrim",
        "key": "maxParityOvertimeTrim",
        "name": "Trim Overtime",
        "needs": [],
        "body": {
          "maxParityOvertime": {
            "fileNamePattern": "Bill_Maher_Interlace_Max_{date}_ot"
          }
        }
      },
      {
        "type": "maxParityOvertimeMetadata",
        "key": "maxParityOvertimeMetadata",
        "name": "Metadata Overtime",
        "needs": [
          "maxParityOvertimeTrim"
        ],
        "body": {}
      },
      {
        "type": "backupUpload",
        "key": "backupUpload",
        "name": "Backup Upload",
        "needs": [
          "recording",
          "vodUpload",
          "maxParityUpload",
          "maxUpload",
          "archiveUpload",
          "archiveOvertimeUpload"
        ],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {}
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "vodStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxParityStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "validateFiles",
        "key": "maxParityValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--maxp"
        }
      },
      {
        "type": "sourceRouter",
        "key": "sourceRouter",
        "name": "Source Router",
        "needs": [
          "updateCinedeckSettings"
        ],
        "body": {
          "settings": {
            "preset": "bill-maher-aws"
          },
          "sourceRouter": {
            "stationId": "stn-x1espzbonemr5xwu"
          }
        }
      },
      {
        "type": "validateFiles",
        "key": "maxValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--max"
        }
      },
      {
        "type": "updateCinedeckSettings",
        "key": "updateCinedeckSettings",
        "name": "Update Cinedeck Settings",
        "needs": [],
        "body": {
          "settings": {
            "preset": "bill-maher-aws"
          }
        }
      },
      {
        "type": "validateFiles",
        "key": "vodValidateFiles",
        "name": "Validate Files",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--vod"
        }
      },
      {
        "type": "validateFiles",
        "key": "linearValidateFiles",
        "name": "Validate Files",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--linear"
        }
      },
      {
        "type": "maxParityMetadata",
        "key": "maxParityMetadata",
        "name": "Metadata",
        "needs": [
          "maxParityTrim"
        ],
        "body": {}
      },
      {
        "type": "contentAcquisitionMetadata",
        "key": "contentAcquisitionMetadata",
        "name": "Metadata",
        "needs": [
          "contentAcquisitionTranscode",
          "recording",
          "maxMetadata"
        ],
        "body": {
          "contentAcquisition": {
            "cc": [
              "en"
            ]
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "contentAcquisitionStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "contentAcquisitionUpload",
        "key": "contentAcquisitionUpload",
        "name": "Upload",
        "needs": [
          "contentAcquisitionStartManualUpload",
          "contentAcquisitionMetadata"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "contentAcquisitionIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "iris": {
            "type": "contentAcquisition",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/contentAcquisition/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "maxParityTrim",
        "key": "maxParityTrim",
        "name": "Trim",
        "needs": [
          "maxTrim"
        ],
        "body": {
          "maxParity": {
            "fileNamePattern": "Bill_Maher_Interlace_Max_{date}"
          }
        }
      },
      {
        "type": "vodTrim",
        "key": "vodTrim",
        "name": "Trim",
        "needs": [
          "maxParityTrim"
        ],
        "body": {}
      },
      {
        "type": "vodMetadata",
        "key": "vodMetadata",
        "name": "Metadata",
        "needs": [
          "vodTrim"
        ],
        "body": {}
      },
      {
        "type": "vodUpload",
        "key": "vodUpload",
        "name": "Upload",
        "needs": [
          "vodStartManualUpload",
          "vodMetadata"
        ],
        "body": {}
      },
      {
        "type": "maxTrim",
        "key": "maxTrim",
        "name": "Trim",
        "needs": [],
        "body": {
          "max": {
            "fileNamePattern": "Bill_Maher_Progressive_Max_{date}"
          }
        }
      },
      {
        "type": "maxMetadata",
        "key": "maxMetadata",
        "name": "Metadata",
        "needs": [
          "maxTrim"
        ],
        "body": {
          "max": {
            "dolby": true,
            "dolbyFileNamePattern": "Bill_Maher_Progressive_Max_ADM_{date}"
          }
        }
      },
      {
        "type": "maxUpload",
        "key": "maxUpload",
        "name": "Upload",
        "needs": [
          "maxStartManualUpload",
          "maxMetadata"
        ],
        "body": {
          "awsSnsTopic": "arn:aws:sns:us-east-1:432857103480:Roadrunner-Stage"
        }
      },
      {
        "type": "linearTrim",
        "key": "linearTrim",
        "name": "Trim",
        "needs": [
          "recording"
        ],
        "body": {}
      },
      {
        "type": "linearMetadata",
        "key": "linearMetadata",
        "name": "Metadata",
        "needs": [
          "linearTrim"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "vodIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "iris": {
            "type": "vod",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/vod/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "linearIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "iris": {
            "type": "linear",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/linear/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "iris": {
            "type": "max",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/max/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "collectS3Links",
        "key": "collectS3Links",
        "name": "Collect S3 Links",
        "needs": [
          "maxUpload",
          "maxParityUpload",
          "vodUpload",
          "linearUpload",
          "contentAcquisitionUpload",
          "archiveUpload",
          "archiveOvertimeUpload"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "maxParityIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "iris": {
            "type": "maxParity",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/maxParity/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "linearUpload",
        "key": "linearUpload",
        "name": "Upload",
        "needs": [
          "linearStartManualUpload",
          "linearValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "linearStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "archiveMetadata",
        "key": "archiveMetadata",
        "name": "Archive Metadata",
        "needs": [
          "maxParityUpload",
          "maxUpload"
        ],
        "body": {
          "archive": {
            "fileNamePattern": "RealTimeWithBillMaher"
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "archiveIrisUpload",
        "name": "Archive Iris Upload",
        "needs": [
          "archiveMetadata",
          "archiveOvertimeMetadata"
        ],
        "body": {
          "iris": {
            "type": "archive",
            "bucket": "s3://cinedeck-roadrunner-testfiles/output/Bill_Maher/{date}/archive/",
            "profile": "cinedeck"
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "archiveStartManualUpload",
        "name": "Archive Start Manual Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "archiveUpload",
        "key": "archiveUpload",
        "name": "Archive Upload",
        "needs": [
          "archiveStartManualUpload",
          "archiveValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "archiveOvertimeMetadata",
        "key": "archiveOvertimeMetadata",
        "name": "Archive Overtime Metadata",
        "needs": [
          "maxParityOvertimeMetadata",
          "archiveMetadata"
        ],
        "body": {
          "archiveOvertime": {
            "fileNamePattern": "Overtime"
          }
        }
      },
      {
        "type": "archiveOvertimeUpload",
        "key": "archiveOvertimeUpload",
        "name": "Archive Overtime Upload",
        "needs": [
          "archiveOvertimeMetadata",
          "archiveValidateFiles",
          "archiveStartManualUpload"
        ],
        "body": {}
      }
    ];
  }

  static getTranscodeTasks(): TaskTemplate[] {
    return [
      {
        "type": "maxParityUpload",
        "key": "maxParityUpload",
        "name": "Upload",
        "needs": [
          "maxParityStartManualUpload",
          "maxParityMetadata"
        ],
        "body": {}
      },
      {
        "type": "backupUpload",
        "key": "backupUpload",
        "name": "Backup Upload",
        "needs": [
          "recording",
          "vodUpload",
          "maxParityUpload",
          "maxUpload"
        ],
        "body": {}
      },
      {
        "type": "collectS3Links",
        "key": "collectS3Links",
        "name": "Collect S3 Links",
        "needs": [
          "backupUpload"
        ],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {
          "record": {
            "autoPlayback": false
          }
        }
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "vodStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodMetadata",
        "key": "vodMetadata",
        "name": "Metadata",
        "needs": [
          "vodTranscode",
          "vodInsertCaptions",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "vodUpload",
        "key": "vodUpload",
        "name": "Upload",
        "needs": [
          "vodStartManualUpload",
          "vodMetadata"
        ],
        "body": {}
      },
      {
        "type": "maxTranscode",
        "key": "maxTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap"
        ],
        "body": {
          "max": {
            "fileNamePattern": "John_Oliver_Progressive_Max_{date}"
          }
        }
      },
      {
        "type": "maxMetadata",
        "key": "maxMetadata",
        "name": "Metadata",
        "needs": [
          "maxTranscode",
          "vodTranscode",
          "recording"
        ],
        "body": {
          "max": {
            "dolby": false,
            "dolbyFileNamePattern": "John_Oliver_Progressive_Max_ADM_{date}"
          }
        }
      },
      {
        "type": "maxUpload",
        "key": "maxUpload",
        "name": "Upload",
        "needs": [
          "maxStartManualUpload",
          "maxMetadata"
        ],
        "body": {
          "awsSnsTopic": "arn:aws:sns:us-east-1:432857103480:Roadrunner-Stage"
        }
      },
      {
        "type": "linearTranscode",
        "key": "linearTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap"
        ],
        "body": {}
      },
      {
        "type": "linearMetadata",
        "key": "linearMetadata",
        "name": "Metadata",
        "needs": [
          "linearTranscode",
          "linearInsertCaptions",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "insertCaptions",
        "key": "vodInsertCaptions",
        "name": "Insert Captions",
        "needs": [
          "vodTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "insertCaptions",
        "key": "linearInsertCaptions",
        "name": "Insert Captions",
        "needs": [
          "linearTranscode",
          "recording",
          "vodInsertCaptions"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "icapStartManual",
        "name": "Approve Start Icap",
        "needs": [],
        "body": {}
      },
      {
        "type": "setupIcap",
        "key": "setupIcap",
        "name": "Setup Icap",
        "needs": [
          "s3downloadVideo"
        ],
        "body": {}
      },
      {
        "type": "startIcap",
        "key": "startIcap",
        "name": "Start Icap",
        "needs": [
          "icapStartManual",
          "setupIcap"
        ],
        "body": {}
      },
      {
        "type": "linearUpload",
        "key": "linearUpload",
        "name": "Upload",
        "needs": [
          "linearStartManualUpload",
          "linearMetadata"
        ],
        "body": {
          "linear": {
            "yakkoApiUrl": "https://yakko.qa.msad.discovery.com/api/material/fulfillment"
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "linearStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "s3downloadVideo",
        "key": "s3downloadVideo",
        "name": "Download S3 Video",
        "needs": [],
        "body": {
          "s3Profile": "",
          "downloadDirectory": "E:\\downloaded\\"
        }
      },
      {
        "type": "validateFiles",
        "key": "linearValidateFiles",
        "name": "Validate Files",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--linear"
        }
      },
      {
        "type": "validateFiles",
        "key": "vodValidateFiles",
        "name": "Validate Files",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--vod"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxParityValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--maxp"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--max"
        }
      },
      {
        "type": "validateFiles",
        "key": "contentAcquisitionValidateFiles",
        "name": "Validate Files",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--ca"
        }
      },
      {
        "type": "maxParityTranscode",
        "key": "maxParityTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "vodTranscode"
        ],
        "body": {
          "maxParity": {
            "fileNamePattern": "John_Oliver_Interlace_Max_{date}"
          }
        }
      },
      {
        "type": "maxParityMetadata",
        "key": "maxParityMetadata",
        "name": "Metadata",
        "needs": [
          "maxParityTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxParityStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodTranscode",
        "key": "vodTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "maxTranscode"
        ],
        "body": {}
      },
      {
        "type": "contentAcquisitionTranscode",
        "key": "contentAcquisitionTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "linearTranscode",
          "maxParityTranscode"
        ],
        "body": {
          "contentAcquisition": {
            "fileNamePattern": "LWT_1228_348_Original_15907_OV-2398TextedHDSDR_en-US_Rev000"
          }
        }
      },
      {
        "type": "contentAcquisitionMetadata",
        "key": "contentAcquisitionMetadata",
        "name": "Metadata",
        "needs": [
          "contentAcquisitionTranscode",
          "recording",
          "maxMetadata"
        ],
        "body": {
          "contentAcquisition": {
            "cc": [
              "en"
            ]
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "contentAcquisitionStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "contentAcquisitionUpload",
        "key": "contentAcquisitionUpload",
        "name": "Upload",
        "needs": [
          "contentAcquisitionStartManualUpload",
          "contentAcquisitionValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "vodIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "iris": {
            "type": "vod",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/vod/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxParityIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "iris": {
            "type": "maxParity",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/maxParity/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "linearIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "iris": {
            "type": "linear",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/linear/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "iris": {
            "type": "max",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/max/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "contentAcquisitionIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "iris": {
            "type": "contentAcquisition",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/contentAcquisition/",
            "profile": ""
          }
        }
      }
    ];
  }

  static getC3Tasks(): TaskTemplate[] {
    return [
      {
        "type": "sourceRouter",
        "key": "sourceRouter",
        "name": "Get Stream",
        "needs": [],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {}
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [
          "c3Upload"
        ],
        "body": {}
      },
      {
        "type": "c3Upload",
        "key": "c3Upload",
        "name": "Upload C3",
        "needs": [
          "recording"
        ],
        "body": {}
      }
    ];
  }

  static getJohnOliver(): TaskTemplate[] {
    return [
      {
        "type": "startManualTask",
        "key": "icapStartManual",
        "name": "Approve Start Icap",
        "needs": [],
        "body": {}
      },
      {
        "type": "setupIcap",
        "key": "setupIcap",
        "name": "Setup Icap",
        "needs": [
          "s3downloadVideo"
        ],
        "body": {}
      },
      {
        "type": "startIcap",
        "key": "startIcap",
        "name": "Start Icap",
        "needs": [
          "icapStartManual",
          "setupIcap"
        ],
        "body": {}
      },
      {
        "type": "linearUpload",
        "key": "linearUpload",
        "name": "Upload",
        "needs": [
          "linearStartManualUpload",
          "linearMetadata"
        ],
        "body": {
          "linear": {
            "yakkoApiUrl": "https://yakko.msad.discovery.com/api/material/fulfillment"
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "linearStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "s3downloadVideo",
        "key": "s3downloadVideo",
        "name": "Download S3 Video",
        "needs": [],
        "body": {
          "s3Profile": "",
          "downloadDirectory": "E:\\downloaded\\"
        }
      },
      {
        "type": "validateFiles",
        "key": "linearValidateFiles",
        "name": "Validate Files",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--linear"
        }
      },
      {
        "type": "validateFiles",
        "key": "vodValidateFiles",
        "name": "Validate Files",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--vod"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxParityValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--maxp"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxValidateFiles",
        "name": "Validate Files",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--max"
        }
      },
      {
        "type": "validateFiles",
        "key": "contentAcquisitionValidateFiles",
        "name": "Validate Files",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "preset": "john_oliver",
          "cliPath": "D:\\tools\\agent\\cli",
          "validation": "--ca"
        }
      },
      {
        "type": "maxParityTranscode",
        "key": "maxParityTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "vodTranscode"
        ],
        "body": {
          "maxParity": {
            "fileNamePattern": "John_Oliver_Interlace_Max_{date}"
          }
        }
      },
      {
        "type": "maxParityMetadata",
        "key": "maxParityMetadata",
        "name": "Metadata",
        "needs": [
          "maxParityTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxParityStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodTranscode",
        "key": "vodTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "maxTranscode"
        ],
        "body": {}
      },
      {
        "type": "contentAcquisitionTranscode",
        "key": "contentAcquisitionTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap",
          "linearTranscode",
          "maxParityTranscode"
        ],
        "body": {
          "contentAcquisition": {
            "fileNamePattern": "{record.additionalMetadata.contentAcquisitionFileName}"
          }
        }
      },
      {
        "type": "contentAcquisitionMetadata",
        "key": "contentAcquisitionMetadata",
        "name": "Metadata",
        "needs": [
          "contentAcquisitionTranscode",
          "recording",
          "maxMetadata"
        ],
        "body": {
          "contentAcquisition": {
            "cc": [
              "en"
            ]
          }
        }
      },
      {
        "type": "startManualTask",
        "key": "contentAcquisitionStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "contentAcquisitionUpload",
        "key": "contentAcquisitionUpload",
        "name": "Upload",
        "needs": [
          "contentAcquisitionStartManualUpload",
          "contentAcquisitionValidateFiles"
        ],
        "body": {}
      },
      {
        "type": "irisUpload",
        "key": "vodIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "iris": {
            "type": "vod",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/vod/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxParityIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "iris": {
            "type": "maxParity",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/maxParity/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "linearIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "linearMetadata"
        ],
        "body": {
          "iris": {
            "type": "linear",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/linear/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "maxIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "maxMetadata"
        ],
        "body": {
          "iris": {
            "type": "max",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/max/",
            "profile": ""
          }
        }
      },
      {
        "type": "irisUpload",
        "key": "contentAcquisitionIrisUpload",
        "name": "Iris Upload",
        "needs": [
          "contentAcquisitionMetadata"
        ],
        "body": {
          "iris": {
            "type": "contentAcquisition",
            "bucket": "s3://iris-anywhere/output/John Oliver/{date}/contentAcquisition/",
            "profile": ""
          }
        }
      },
      {
        "type": "maxParityUpload",
        "key": "maxParityUpload",
        "name": "Upload",
        "needs": [
          "maxParityStartManualUpload",
          "maxParityMetadata"
        ],
        "body": {}
      },
      {
        "type": "backupUpload",
        "key": "backupUpload",
        "name": "Backup Upload",
        "needs": [
          "recording",
          "vodUpload",
          "maxParityUpload",
          "maxUpload",
          "linearUpload",
          "contentAcquisitionUpload"
        ],
        "body": {}
      },
      {
        "type": "collectS3Links",
        "key": "collectS3Links",
        "name": "Collect S3 Links",
        "needs": [
          "backupUpload"
        ],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {
          "record": {
            "autoPlayback": false
          }
        }
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "vodStartManualUpload",
        "name": "Approve Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodMetadata",
        "key": "vodMetadata",
        "name": "Metadata",
        "needs": [
          "vodTranscode",
          "vodInsertCaptions",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "vodUpload",
        "key": "vodUpload",
        "name": "Upload",
        "needs": [
          "vodStartManualUpload",
          "vodMetadata"
        ],
        "body": {}
      },
      {
        "type": "maxTranscode",
        "key": "maxTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap"
        ],
        "body": {
          "max": {
            "fileNamePattern": "John_Oliver_Progressive_Max_{date}"
          }
        }
      },
      {
        "type": "maxMetadata",
        "key": "maxMetadata",
        "name": "Metadata",
        "needs": [
          "maxTranscode",
          "vodTranscode",
          "recording"
        ],
        "body": {
          "max": {
            "dolby": false,
            "dolbyFileNamePattern": "John_Oliver_Progressive_Max_ADM_{date}"
          }
        }
      },
      {
        "type": "maxUpload",
        "key": "maxUpload",
        "name": "Upload",
        "needs": [
          "maxStartManualUpload",
          "maxMetadata"
        ],
        "body": {
          "awsSnsTopic": "arn:aws:sns:us-east-1:432857103480:Roadrunner-Prod"
        }
      },
      {
        "type": "linearTranscode",
        "key": "linearTranscode",
        "name": "Transcode",
        "needs": [
          "startIcap"
        ],
        "body": {}
      },
      {
        "type": "linearMetadata",
        "key": "linearMetadata",
        "name": "Metadata",
        "needs": [
          "linearTranscode",
          "linearInsertCaptions",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "insertCaptions",
        "key": "vodInsertCaptions",
        "name": "Insert Captions",
        "needs": [
          "vodTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "insertCaptions",
        "key": "linearInsertCaptions",
        "name": "Insert Captions",
        "needs": [
          "linearTranscode",
          "recording",
          "vodInsertCaptions"
        ],
        "body": {}
      }
    ];
  }

  static getNflTasks(): TaskTemplate[] {
    return [
      {
        "type": "maxParityUpload",
        "key": "maxParityUpload",
        "name": "Max Parity Upload",
        "needs": [
          "maxParityStartManualUpload",
          "maxParityMetadata"
        ],
        "body": {}
      },
      {
        "type": "backupUpload",
        "key": "backupUpload",
        "name": "Backup Upload",
        "needs": [
          "recording",
          "vodUpload",
          "maxParityUpload",
          "maxUpload"
        ],
        "body": {}
      },
      {
        "type": "recording",
        "key": "recording",
        "name": "Recording",
        "needs": [],
        "body": {
          "record": {
            "autoPlayback": false
          }
        }
      },
      {
        "type": "finished",
        "key": "finished",
        "name": "Finished",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "vodStartManualUpload",
        "name": "VOD Start Manual Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodMetadata",
        "key": "vodMetadata",
        "name": "VOD Metadata",
        "needs": [
          "vodTranscode",
          "vodInsertCaptions",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "vodUpload",
        "key": "vodUpload",
        "name": "VOD Upload",
        "needs": [
          "vodStartManualUpload",
          "vodMetadata"
        ],
        "body": {}
      },
      {
        "type": "maxTranscode",
        "key": "maxTranscode",
        "name": "Max Transcode",
        "needs": [
          "startIcap"
        ],
        "body": {
          "max": {
            "fileNamePattern": "NFL_Progressive_Max_{date}"
          }
        }
      },
      {
        "type": "maxMetadata",
        "key": "maxMetadata",
        "name": "Max Metadata",
        "needs": [
          "maxTranscode",
          "vodTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "maxUpload",
        "key": "maxUpload",
        "name": "Max Upload",
        "needs": [
          "maxStartManualUpload",
          "maxMetadata"
        ],
        "body": {}
      },
      {
        "type": "insertCaptions",
        "key": "vodInsertCaptions",
        "name": "VOD Insert Captions",
        "needs": [
          "vodTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "icapStartManual",
        "name": "Approve Start Icap",
        "needs": [],
        "body": {}
      },
      {
        "type": "setupIcap",
        "key": "setupIcap",
        "name": "Setup Icap",
        "needs": [
          "s3downloadVideo"
        ],
        "body": {}
      },
      {
        "type": "startIcap",
        "key": "startIcap",
        "name": "Start Icap",
        "needs": [
          "icapStartManual",
          "setupIcap"
        ],
        "body": {}
      },
      {
        "type": "s3downloadVideo",
        "key": "s3downloadVideo",
        "name": "Download S3 Video",
        "needs": [],
        "body": {
          "s3Profile": "cinedeck",
          "downloadDirectory": "E:\\downloaded\\"
        }
      },
      {
        "type": "validateFiles",
        "key": "vodValidateFiles",
        "name": "VOD Validate Files",
        "needs": [
          "vodMetadata"
        ],
        "body": {
          "validation": "--vod"
        }
      },
      {
        "type": "validateFiles",
        "key": "maxParityValidateFiles",
        "name": "Max Parity Validate Files",
        "needs": [
          "maxParityMetadata"
        ],
        "body": {
          "validation": "--maxp"
        }
      },
      {
        "type": "maxParityTranscode",
        "key": "maxParityTranscode",
        "name": "Max Parity Transcode",
        "needs": [
          "startIcap",
          "vodTranscode"
        ],
        "body": {
          "maxParity": {
            "fileNamePattern": "NFL_Interlace_Max_{date}"
          }
        }
      },
      {
        "type": "maxParityMetadata",
        "key": "maxParityMetadata",
        "name": "Max Parity Metadata",
        "needs": [
          "maxParityTranscode",
          "recording"
        ],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxParityStartManualUpload",
        "name": "Max Parity Start Manual Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "startManualTask",
        "key": "maxStartManualUpload",
        "name": "Max Start Manual Upload",
        "needs": [],
        "body": {}
      },
      {
        "type": "vodTranscode",
        "key": "vodTranscode",
        "name": "VOD Transcode",
        "needs": [
          "startIcap",
          "maxTranscode"
        ],
        "body": {}
      }
    ];
  }

}